import { FC, CSSProperties } from 'react';
import cn from 'bem-cn';

import { SpinnerProps } from './Spinner.types';
import './Spinner.scss';

const b = cn('spinner');

export const Spinner: FC<SpinnerProps> = ({
    size = 'medium',
    variant = 'primary',
    className,
    color,
    customSize,
    'aria-label': ariaLabel = 'Загрузка...',
}) => {
    const spinnerClasses = b(
        {
            size,
            variant,
        },
        [],
    ).mix(className);

    const spinnerStyle: CSSProperties = {
        ...(color && ({ '--spinner-color': color } as CSSProperties)),
        ...(customSize && ({ '--spinner-size': `${customSize}px` } as CSSProperties)),
    };

    return (
        <div className={spinnerClasses} style={spinnerStyle} role="status" aria-label={ariaLabel}>
            <div className={b('circle')} />
        </div>
    );
};
